<script>
import { resizeImage } from '~/util/img.util'
export default {
  props: {
    projectItem: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      imageWidth: 0,
      imageHeight: 0
    }
  },
  computed: {
    projectItemProjectImg() {
      const vm = this
      let returnImage = ''
      if (vm.projectItem.projectImgOssUrl) {
        returnImage = resizeImage({
          src: vm.projectItem.projectImgOssUrl,
          width: '155',
          height: '113'
        })
      } else {
        returnImage = resizeImage({
          src: this.defaultProjectImg,
          width: '155',
          height: '113'
        })
      }
      return returnImage
    }
  },
  created() {
    this.getImageWidthAndHeight()
  },
  methods: {
    resizeImage,
    getImageWidthAndHeight
  }
}

function getImageWidthAndHeight() {
  if (this.$_thebox.clientWidth > 940) {
    this.isBigScreen = true
    this.imageWidth = 155
    this.imageHeight = 113
  } else {
    this.isBigScreen = false
    this.imageWidth = 120
    this.imageHeight = 88
  }
}
</script>

<template>
  <div class="project_list_project_item_container bottom_line_L_R_project_list">
    <div class="project_list_project_item_left_container">
      <span class="project_list_project_item_left_stage">{{
        projectItem.stage
      }}</span>
      <img
        :src="projectItemProjectImg"
        class="project_list_project_item_left_image"
      />
      <div class="icon_container">
        <img
          v-if="projectItem.videoNum > 0"
          class="icon_video"
          src="../images/icon-video.png"
        />
        <img
          v-if="projectItem.vrUrl"
          class="icon_vr"
          src="../images/icon-vr.png"
        />
      </div>
      <img />
    </div>
    <div class="project_list_project_item_right_container">
      <span class="project_list_project_item_right_title two-line-text">{{
        projectItem.projectName
      }}</span>
      <div
        v-if="
          projectItem.decorationArea ||
            projectItem.houseType ||
            projectItem.style ||
            projectItem.decorationBudget
        "
        class="project_list_project_item_right_info"
      >
        <span v-if="projectItem.decorationArea"
          >{{ projectItem.decorationArea }}m²</span
        >
        <span v-if="projectItem.houseType">{{ projectItem.houseType }}</span>
        <span v-if="projectItem.style">{{ projectItem.style }}</span>
        <span v-if="projectItem.decorationBudget"
          >{{ projectItem.decorationBudget }}万</span
        >
      </div>
      <div class="project_list_project_item_right_location">
        <!-- <img
          v-if="projectItem.distance"
          class="project_list_project_item_right_location_icon"
          src="../images/location_icon.png"
        />
        <span v-if="projectItem.distance">{{ projectItem.distance }}</span>-->

        <span>
          <img class="map_icon" src="~/assets/image/icon/icon-location.png" />
          {{ projectItem.regionName }}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.map_icon {
  height: 11px;
}
.bottom_line_L_R_project_list {
  position: relative;
}
.bottom_line_L_R_project_list::after {
  position: absolute;
  bottom: 0px;
  left: 15px;
  right: 15px;
  display: block;
  background: #eff1f2;
  content: '';
  height: 1px;
  transform: scale(1, 0.5);
  -webkit-transform: scale(1, 0.5);
}

.project_list_project_item_container {
  display: flex;
  padding: 20px 15px 20px 15px;

  @media screen and(min-width: 940px) {
    .project_list_project_item_left_container {
      height: 113px;
      width: 155px;
    }
  }

  .project_list_project_item_left_container {
    // flex: 0 0 35%;
    position: relative;
    .project_list_project_item_left_stage {
      position: absolute;
      top: 10px;
      left: 10px;
      display: block;
      padding: 2px 6px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(42, 42, 42, 1);
      line-height: 14px;
    }

    .project_list_project_item_left_image {
      object-fit: cover;
      border-radius: 4px;
      width: 155px;
      height: 113px;
    }
    .icon_container {
      bottom: 8px;
      display: flex;
      position: absolute;

      %icon_common {
        width: 20px;
        height: 20px;
        margin-left: 10px;
      }
      .icon_video {
        @extend %icon_common;
        left: 8px;
      }

      .icon_vr {
        @extend %icon_common;
        left: 35px;
      }
    }
  }

  .project_list_project_item_right_container {
    // flex: 0 0 55%;
    padding-left: 15px;
    // max-width: 70%;
    .project_list_project_item_right_title {
      font-size: 16px;
      font-weight: 500;
      color: #444;
      line-height: 20px;
    }

    .project_list_project_item_right_info {
      padding-top: 13px;
      font-size: 0;
      > span {
        padding-right: 5px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 14px;
        margin-right: 0px;
      }
    }

    .project_list_project_item_right_location {
      padding-top: 14px;
      line-height: 14px;
      display: flex;
      align-items: center;
      font-size: 0;

      .project_list_project_item_right_location_icon {
        width: 9px;
        height: 11px;
        margin-right: 5px;
        display: inline-block;
      }

      > span {
        font-size: 12px;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        line-height: 14px;
        padding-right: 10px;
      }
    }
  }
  @media screen and(max-width: 940px) {
    .project_list_project_item_left_container {
      width: 155px;
      height: 113px;
    }
    .project_list_project_item_right_container {
      // flex: 0 0 45%;
      flex: 1;
      .project_list_project_item_right_info {
        padding-top: 10px !important;
      }
      .project_list_project_item_right_location {
        padding-top: 10px !important;
      }
    }
  }
}
</style>
